export default __webpack_public_path__ + "static/media/confections-moufette-og.4beca246.png";